module.exports = __webpack_public_path__ + "static/media/huc.63f3ee85.svg";